import React, {useState, useEffect, useRef} from 'react';
import Button from 'react-bootstrap/Button';
import {useInterval, updateUTCDate} from '../../common/app_common.js';
import {PageNation} from '../../common/component_common.js';
import {getApiEdgeCount, getApiEdge, getApiEdgeId, putApiEdgeIdStatus} from '../../common/fetch_api/edge'
import {BsExclamationCircle, BsTrash, BsChevronExpand} from 'react-icons/bs'
import {EdgeInfoModal} from './modals';
import {DecideWindow} from '../../common/modal_common.js';

const PAGE_PER = 17;

export const View = ({runUpdateTab}) => {
    
    const [update, setUpdate] = useState(false);

    const [tableSpinner, setTableSpinner] = useState(false);
    const [rejectEdgeList, setRejectEdgeList] = useState(null);

    const [edgeSelCount, setEdgeSelCount] = useState(1);
    const [curPageState, setCurPageState] = useState(1);
    const curPageRef = useRef(0);
    const setPageMove = (e) => {
        setCurPageState(e);
        runUpdate();
    }
    
    const [edgeInfoId, setEdgeInfoId] = useState(null);
    
    const sortInfo = useRef({title:'', order:''});
    
    const [modalEdgeInfo, setModalEdgeInfo] = useState(false);
    const closeModalEdgeInfo = () => setModalEdgeInfo(false);
    const showModalEdgeInfo = (edgeId) => {
        setEdgeInfoId(edgeId);
        setModalEdgeInfo(true);
    }

    const [edgeId, setEdgeId] = useState('');
    const [modalDecide, setModalDecide] = useState(false);
    const closeModalDecide = () => setModalDecide(false);
    const showModalDecide = (edgeId) => {
        setEdgeId(edgeId);
        setModalDecide(true);
    };

    const getEdges = () => {
        Promise.resolve( getApiEdgeCount('rejected') )
        .then( data => {
            if(data && data.count > 0)
            {
                setEdgeSelCount(data.count);

                curPageRef.current.value = Math.min(Math.ceil(data.count/PAGE_PER), curPageState);
                setCurPageState(parseInt(curPageRef.current.value));

                Promise.resolve( getApiEdge('rejected', PAGE_PER, curPageRef.current.value, sortInfo.current.title, sortInfo.current.order) )
                .then( idArr => {
                    let apiArr = [];
                    for( let id of idArr )
                    {
                        if( id.length > 1)
                        {
                            apiArr.push( getApiEdgeId(id) );
                        }
                    }

                    Promise.all( apiArr )
                    .then( edgeArr => {
                        
                        // edgeArr.sort((a, b) => strArraySortAsc(a.name.toLowerCase(), b.name.toLowerCase()));

                        let html = [];
                        for(let edge of edgeArr)
                        {
                            let type = 'T';
                            if( edge.type === 'm-agent' ) type = 'M';
                            else if( edge.type === 's-agent' ) type = 'S';
                            else if( edge.type === 'r-agent' ) type = 'R';
                            
                            let curTime = new Date();
                            let checkIn = new Date(0);
                            checkIn.setUTCSeconds(edge.sec);

                            html.push(
                                <tr key={edge.id} id={edge.id}>
                                    <td><div className="edge-box edge-default"><span className="edge-item">{type}</span></div></td>
                                    <td title={edge.id}>{edge.id}</td>
                                    <td title={edge.fingerprint}>{edge.fingerprint}</td>
                                    <td title={edge.name}>{edge.name}</td>
                                    <td className={`${(curTime.getTime() - checkIn.getTime()) >= 60000? "text-warning":""}`}
                                        title={updateUTCDate(checkIn)}>{updateUTCDate(checkIn)}</td>
                                    <td title={edge.clientIp}>{edge.clientIp}</td>
                                    <td>
                                        <Button variant='primary' className="btn btn-icon" data-bs-toggle="tooltip" title="Details" onClick={() => {showModalEdgeInfo(edge.id);}}><BsExclamationCircle/></Button>
                                    </td>
                                    <td>
                                        <Button variant="danger" className="btn btn-icon" onClick={() => {showModalDecide(edge.id)}}><BsTrash/></Button>
                                    </td>
                                </tr>
                            );
                        }

                        setTimeout(() => {setTableSpinner(false);}, 700);
                        setRejectEdgeList(html);
                    })
                    .catch( e => {
                        setTimeout(() => {setTableSpinner(false);}, 700);
                    });
                })
                .catch( e => {
                    setTimeout(() => {setTableSpinner(false);}, 700);
                });
            }
            else
            {
                setRejectEdgeList([]);
                curPageRef.current.value = 1;
                setCurPageState(1);
                setEdgeSelCount(1);
                setTimeout(() => {setTableSpinner(false);}, 700);
            }
        })
        .catch( e => {
            setTimeout(() => {setTableSpinner(false);}, 700);
        });
    };

    const SetDecideBody = () => {
        return (
            <div className='text-center'>
                <p>Are you sure you want to delete this Edge?</p>
            </div>
    )};

    function onClickDecide(is)
    {
        if(is)
        {
            Promise.resolve( putApiEdgeIdStatus('dismiss', edgeId) )
            .then( done => {
                runUpdate();
            })
            .catch( err => {});
        }
    }
    
    function toggleSort(title)
    {
        let curTitle = sortInfo.current.title;
        let curOrder = sortInfo.current.order;

        if( curTitle === title )
        {
            if( curOrder === 'asc' )
            {
                curOrder = 'desc';
            }
            else
            {
                curOrder = 'asc';
            }
        }
        else
        {
            curTitle = title;
            curOrder = 'asc';
        }

        sortInfo.current = {title: curTitle, order: curOrder};

        getEdges();
    }

    const runUpdate = () => {
        setUpdate(!update);
    };

    useEffect(() => {
        setTableSpinner(true);
        getEdges();
    }, [update, curPageState, runUpdateTab]);

    // useInterval(() =>
    // {
    //     runUpdate();
    // }, 30000 );

    return (
        <>
            <div className="section rejected-area position-relative mt-3">
                {tableSpinner && <div className="table-spinner spinner-border text-default"></div>}
                <table className="table">
                    <thead>
                        <tr>
                            <th className="sorting" onClick={() => {toggleSort('type');}}>Type<BsChevronExpand /></th>
                            <th className="sorting" onClick={() => {toggleSort('id');}}>EdgeId<BsChevronExpand /></th>
                            <th className="sorting" onClick={() => {toggleSort('fingerprint');}}>Fingerprint<BsChevronExpand /></th>
                            <th className="sorting" onClick={() => {toggleSort('name');}}>Name<BsChevronExpand /></th>
                            <th>Latest Check in</th>
                            <th>Client IP</th>
                            <th></th>
                            <th></th>
                        </tr>
                    </thead>
                    <tbody id='rejectTbody'>
                        {rejectEdgeList}
                    </tbody>
                </table>
            </div>
            <PageNation
                curPageState={curPageState}
                setCurPageState={setPageMove}
                selCount={edgeSelCount}
                pagePer={PAGE_PER}
                ref={curPageRef}
            ></PageNation>
            {modalEdgeInfo&&<EdgeInfoModal edgeId={edgeInfoId} show={modalEdgeInfo} handleClose={closeModalEdgeInfo}></EdgeInfoModal>}
            {modalDecide&&<DecideWindow result={onClickDecide} show={modalDecide} handleClose={closeModalDecide} body={<SetDecideBody/>} okButtonTxt={'Remove'}></DecideWindow>}
        </>
    )
}
